import { documentationActions } from '../../actions/constant';
const { SUCCESS_GET_PROVIDER_LIST, FAILURE_GET_PROVIDER_LIST, LOADING_GET_PROVIDER_LIST } =
  documentationActions;

const intitialstate: object = {
  response: null,
  isGetList: false,
  loading: false,
};

export const getAllTherapistListReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_PROVIDER_LIST: {
      return {
        ...state,
        isGetList: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_GET_PROVIDER_LIST:
      return {
        ...state,
        isGetList: false,
        response: action.payload,
        loading: false,
      };

    case LOADING_GET_PROVIDER_LIST:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
